
<div class="header" mat-dialog-actions>
    <div class="navigation desktop">
        <div class="left">
            <button mat-button>Delete</button>
        </div>
        <div class="middle">
            <button (click)="print()" mat-button>Print</button>
            <button (click)="recall()" mat-button>Recall</button>
            <button (click)="clearGroups()" mat-button>Clear groups</button>
        </div>
        <div class="right">
            <button mat-button mat-dialog-close>Close</button>
        </div>
    </div>

    <div class="navigation mobile">
        <div class="left">
            <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
        </div>
        <div class="middle">
            <button mat-button>Previous</button>
            <button mat-button>Next</button>
        </div>
        <div class="right">
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item>
                  <mat-icon>add</mat-icon>
                  <span>New Item</span>
                </button>
                <button mat-menu-item>
                  <mat-icon>content_copy</mat-icon>
                  <span>Duplicate</span>
                </button>
                <button mat-menu-item>
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>

        </div>
    </div>
</div>

<div class="container" mat-dialog-content>
    <div class="left">
        <div class="group-controls">
            <mat-form-field appearance="outline">
                <mat-label>New group</mat-label>
                <input matInput [(ngModel)]="newGroupName" (keyup.enter)="addGroup()" placeholder="Parts to order">
            </mat-form-field>
            <button (click)="addGroup()" mat-raised-button color="primary">
                <mat-icon>add</mat-icon>
                Add group
            </button>
            <button (click)="clearGroups()" mat-stroked-button>
                <mat-icon>clear_all</mat-icon>
                Clear all
            </button>
        </div>

        <div class="group-list" *ngIf="taskGroups.length > 0">
            <button *ngFor="let group of taskGroups; trackBy: trackByGroup" type="button" class="group-chip" (click)="removeGroup(group)">
                {{group.name}}
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="task-group" *ngFor="let group of groupedTaskSections; trackBy: trackByGroup">
            <div class="group-heading" *ngIf="taskGroups.length > 0">
                <span>{{group.name}}</span>
                <div class="group-heading-actions">
                    <small>{{group.tasks.length}} task{{group.tasks.length === 1 ? '' : 's'}}</small>
                    <button type="button" (click)="printGroup(group)" mat-icon-button [attr.aria-label]="'Print ' + group.name">
                        <mat-icon>print</mat-icon>
                    </button>
                </div>
            </div>

            <div class="task" *ngFor="let task of group.tasks; trackBy: trackByTask">
                <div (click)="openTask(task)" class="subject">#{{task.id}} {{task.subject}}</div>
                <div class="group-select">
                    <mat-form-field appearance="outline">
                        <mat-label>Group</mat-label>
                        <mat-select [ngModel]="getTaskGroupId(task)" (ngModelChange)="setTaskGroup(task, $event)">
                            <mat-option value="">Ungrouped</mat-option>
                            <mat-option *ngFor="let option of taskGroups" [value]="option.id">{{option.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="comment"><input [placeholder]="getLastComment(task)" [value]="getCurrentComment(task)" (blur)="saveTask(task, $event)"></div>
                <div class="actions">
                    <button (click)="completeTask(task)" mat-button>Completed</button>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="right">
        <input-note [note]="'test'"></input-note>
        <input-text label="Note"></input-text>
        <input-text label="Note"></input-text>
        <input-radio label="Sorted"></input-radio>
    </div> -->
</div>

<div mat-dialog-actions>

</div>
